var _defs, _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStaytoenjoylogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 51 51",
    width: 51,
    height: 51,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "staytoenjoylogo-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 50l0.23-50 50 0.23-0.23 50z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.228,-50,49.999,.228,25,50.114)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000000"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: url(#g1) } \n\t\t.s1 { fill: #ffffff } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m25.2 0.1c13.8 0.1 25 11.3 24.9 25.1 0 13.8-11.3 25-25.1 24.9-13.8 0-24.9-11.3-24.9-25.1 0.1-13.8 11.3-24.9 25.1-24.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m41.9 17.7c-1.5-1.8-3.7-2.9-6.1-3.1-0.3 0-0.6-0.1-1-0.1-3 0-5.4 1.6-7.2 3.5-0.4 0.4-0.4 1.1-0.1 1.7 0.5 0.9 1.8 0.9 2.5 0.1 1.3-1.3 2.9-2.2 4.8-2.2 0.3 0 0.6-0.1 0.8-0.1 3.6 0.4 6 3.5 6 7.6 0 4.4-2.8 7.5-6.8 7.5-5.6 0-8.4-7.9-8.4-8-0.1-0.4-3.6-10-11.2-10-2.8 0-5.3 1.1-7.1 3.1-1.7 1.9-2.6 4.5-2.6 7.4 0 2.8 0.9 5.4 2.6 7.3 1.6 1.8 3.8 2.9 6.2 3.1 0.3 0 0.6 0.1 0.9 0.1 3.1 0 5.5-1.5 7.3-3.4 0.4-0.4 0.4-1.1 0.1-1.6-0.6-0.9-1.8-1-2.6-0.2-1.2 1.2-2.8 2.2-4.8 2.2-0.2 0-0.5 0-0.8 0-3.5-0.4-6-3.5-6-7.5 0-4.4 2.9-7.6 6.8-7.6 5.5 0 8.4 7.8 8.4 8 0.2 0.6 3.6 10.1 11.2 10.1 2.8 0 5.3-1.2 7.1-3.2 1.7-1.9 2.7-4.5 2.7-7.3 0-2.9-1-5.5-2.7-7.4z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaytoenjoylogo);
export default __webpack_public_path__ + "static/media/staytoenjoylogo.7e31389abd6b01030e6464d979fabced.svg";
export { ForwardRef as ReactComponent };